/*
 * サブシステム名：支払
 * 機能名：支払明細一覧
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdRadioButton from '@/components/DdRadioButton'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdDateBox from '@/components/DdDateBox'
import DdTextBox from '@/components/DdTextBox.vue'
import DdCheckbox from '@/components/DdCheckbox.vue'
import DdNumericBox from '@/components/DdNumericBox'
import flowMixin from '@/mixins/flowMixins'

import modals from '@/ddv2.library/modals'
import filter from '@/rahmen/utils/filters'
import message from '@/ddv2.library/messages'

import D2payd0030 from '@/views/PAY/D2PAYD0030.vue'

export default {
  name: 'ShiharaiMeisaiList',
  mixins: [flowMixin],
  data: () => ({
    rows: [],
    params: {},
    shiharaiKihon: {},
    shiharaisaki: {},
    expansionPanel: [0, 1],
    shiharaisakiCdNmText: '',
    eigyoshoCdNmText: '',
    shimeDateText: '',
    shiharaishoText: '',
    unchinGoukeiSum: 0,
    unchinSum: 0,
    warimashiSum: 0,
    sonotaKazeiSum: 0,
    taxSum: 0,
    hiwaySum: 0,
    sonotaUchizeiSum: 0,
    sonotaHikazeiSum: 0,
    conditions: {
      shiharaiYmd: '',
      shiharaiYm: '',
      shimeDay: '',
      shiborikomiStartYmd: '',
      shiborikomiEndYmd: '',
      shiharaisakiId: '',
      eigyoshoId: '',
      shiharaishoKarihakkoFlg: false,
      kingakuZeroFlg: false,
      kingakuKakutei: '01',
      shimebiIgaiHyojiFlg: false,
      shiharaiDomeHyojiFlg: false
    },
    page: 1,
    modeKengen: 0,
    // 表示制御
    dispShiharaisho: '',
    dispShiharaiMeisaiIchiranCsv: '',
    // ダイアログ
    showShiharaiBikoEditDialog: false,
    shiharaiKihonClone: {},
    lastShimeYmd: ''
  }),
  components: {
    DdSubHeader,
    DdRadioButton,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdDateBox,
    DdCheckbox,
    DdTextBox,
    DdNumericBox,
    // ダイアログ
    D2payd0030
  },
  computed: {
    filteredRows () {
      return this.rows.map((elem) => {
        // 数値項目編集
        elem.unchinGokeiZeikomiDisp = (elem.unchinGokeiZeikomi ? filter.numericFormatter(elem.unchinGokeiZeikomi) : 0) + '円'
        elem.kihonUnchinDisp = (elem.kihonUnchin ? filter.numericFormatter(elem.kihonUnchin) : 0) + '円'
        elem.jikanWarimashiKingakuDisp = (elem.jikanWarimashiKingaku ? filter.numericFormatter(elem.jikanWarimashiKingaku) : 0) + '円'
        elem.kyoriWarimashiKingakuDisp = (elem.kyoriWarimashiKingaku ? filter.numericFormatter(elem.kyoriWarimashiKingaku) : 0) + '円'
        elem.keisuWarimashiKingakuDisp = (elem.keisuWarimashiKingaku ? filter.numericFormatter(elem.keisuWarimashiKingaku) : 0) + '円'
        elem.nenryoWarimashiKingakuDisp = (elem.nenryoWarimashiKingaku ? filter.numericFormatter(elem.nenryoWarimashiKingaku) : 0) + '円'
        elem.userKazeiKingakuGokeiDisp = (elem.userKazeiKingakuGokei ? filter.numericFormatter(elem.userKazeiKingakuGokei) : 0) + '円'
        elem.taxDisp = (elem.tax ? filter.numericFormatter(elem.tax) : 0) + '円'
        elem.hiwayPriceDisp = (elem.hiwayPrice ? filter.numericFormatter(elem.hiwayPrice) : 0) + '円'
        elem.userUchizeiKingakuGokeiDisp = (elem.userUchizeiKingakuGokei ? filter.numericFormatter(elem.userUchizeiKingakuGokei) : 0) + '円'
        elem.userHikazeiKingakuGokeiDisp = (elem.userHikazeiKingakuGokei ? filter.numericFormatter(elem.userHikazeiKingakuGokei) : 0) + '円'
        elem.shiharaiJuryoDisp = (elem.shiharaiJuryo ? filter.numericFormatter(elem.shiharaiJuryo) : 0)
        elem.shiharaiSuryoDisp = (elem.shiharaiSuryo ? filter.numericFormatter(elem.shiharaiSuryo) : 0)
        elem.tankaDisp = (elem.tanka ? filter.numericFormatter(elem.tanka) : 0) + '円'
        // 日付項目編集
        elem.sagyoYoteiYmdDisp = elem.sagyoYoteiYmd ? filter.dateFormatter(elem.sagyoYoteiYmd) : ''
        elem.shiharaiYoteiYmdDisp = elem.shiharaiYoteiYmd ? filter.dateFormatter(elem.shiharaiYoteiYmd) : ''
        return elem
      })
    },
    isOutputButtonDisabled () {
      return this.rows.length === 0
    },
    isShiharai () {
      return this.params.shiharaisho !== '未出力'
    },
    isShiharaiTorikeshi () {
      return this.params.shiharaisho === '取消済'
    },
    isKarihakko () {
      return this.params.shiharaishoKarihakkoFlg
    },
    isNotExistShiharaishoLayoutKbn () {
      return !this.shiharaisaki.shiharaishoLayoutKbn && !this.shiharaisaki.shiharaiMeisaishoLayoutKbn
    },
    isNoParam () {
      return Object.keys(this.params).length === 0
    },
    isShoukaiMode () {
      return this.modeKengen === 0
    },
    isBikoButtonDisp () {
      return this.isShiharai && !this.isNoParam
    },
    isPrintAgainButtonDisp () {
      return this.isShiharai && !this.isShiharaiTorikeshi && !this.isNoParam
    },
    isCancelButtonDisp () {
      return this.isShiharai && !this.isShiharaiTorikeshi && !this.isKarihakko && this.modeKengen === 2 && !this.isNoParam
    },
    isPrintButtonDisp () {
      return !this.isShiharai && !this.isShoukaiMode && !this.isNoParam
    },
    apiPathSearch () {
      var path = ''
      if (this.conditions.shiharaisho === '未出力') {
        // 未支払（発注情報）の場合
        path = '/api/v1/d2payd0020/searchShiharaiMeisaiWork'
      } else {
        path = '/api/v1/d2payd0020/searchShiharaiMeisai'
      }
      return path
    }
  },
  created () {
    this.params = this.$route.params
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {}
    },
    initialize: function () {
      const self = this
      const opt = {
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.headers = [
              { text: 'No', value: 'shiharaiMeisaiNo' },
              { text: '発注番号', value: 'hacchuNo' },
              { text: '発注先区分', value: 'hacchusakiKbnNm' },
              { text: '運賃確定状況', value: 'unchinKakuteiFlgNm' },
              { text: '作業予定日', value: 'sagyoYoteiYmdDisp' },
              { text: '運賃合計', value: 'unchinGokeiZeikomiDisp', align: 'end' },
              { text: '発地', value: 'hatsuchiNm' },
              { text: '着地', value: 'chakuchiNm' },
              { text: '(基本運賃)', value: 'kihonUnchinDisp', align: 'end' },
              { text: '(時間割増)', value: 'jikanWarimashiKingakuDisp', align: 'end' },
              { text: '(距離割増)', value: 'kyoriWarimashiKingakuDisp', align: 'end' },
              { text: '(係数割増)', value: 'keisuWarimashiKingakuDisp', align: 'end' },
              { text: '(燃料割増)', value: 'nenryoWarimashiKingakuDisp', align: 'end' },
              { text: '(その他課税)', value: 'userKazeiKingakuGokeiDisp', align: 'end' },
              { text: '(消費税)', value: 'taxDisp', align: 'end' },
              { text: '(高速代)', value: 'hiwayPriceDisp', align: 'end' },
              { text: '(その他内税)', value: 'userUchizeiKingakuGokeiDisp', align: 'end' },
              { text: '(その他非課税)', value: 'userHikazeiKingakuGokeiDisp', align: 'end' },
              { text: '品名コード/名称', value: 'hinmeiCdNm' },
              { text: '重量', value: 'shiharaiJuryoDisp', align: 'end' },
              { text: '数量', value: 'shiharaiSuryoDisp', align: 'end' },
              { text: '単位', value: 'suryoTaniSbtNm' },
              { text: '得意先コード/名称', value: 'torihikisakiCdNm' },
              { text: '運賃計算', value: 'unchinKeisanKbnNm' },
              { text: '単価', value: 'tankaDisp', align: 'end' },
              { text: '支払日', value: 'shiharaiYoteiYmdDisp' },
              { text: '発地日時', value: 'hatsuchiYmdHms' },
              { text: '着地日時', value: 'chakuchiYmdHms' },
              { text: '備考', value: 'shiharaiBiko' }
              // { text: '明細番号', value: 'hacchuMeisaiNo' },
              // { text: '品目番号', value: 'hacchuHinmokuNo' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            if (self.isNoParam) {
              // 支払一覧画面からパラメータが渡されていない（当画面をリロードした）場合
              // 支払一覧画面から受け取ったパラメータをキャッシュから再現するようにしている
              self.loadFromCache()
                .then((c) => {
                  self.params = c.value.params || {}
                  resolve()
                })
            } else {
              resolve()
            }
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          self.conditions = { ...self.conditions, ...c }
          var shimebiIgaiHyojiFlgBool = c.shimebiIgaiHyojiFlg === 'true'
          self.conditions.shimebiIgaiHyojiFlg = shimebiIgaiHyojiFlgBool
          var shiharaiDomeHyojiFlgBool = c.shiharaiDomeHyojiFlg === 'true'
          self.conditions.shiharaiDomeHyojiFlg = shiharaiDomeHyojiFlgBool
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                // 画面起動時に検索するため、ユーザ保存項目を復元してから検索する
                self.initSearch()
                  .then(() => {
                    resolve()
                  })
                // resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            self.params = c.cache.value ? c.cache.value.params || {} : self.params
            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
      this.getShimeJisseki()
    },
    initSearch: function () {
      const self = this
      return new Promise(resolve => {
        if (self.isNoParam) { return resolve() }
        self.shiharaisakiCdNmText = self.params.shiharaisakiCd ? self.params.shiharaisakiCd + ':' + self.params.shiharaisakiNm : ' '
        self.eigyoshoCdNmText = self.params.eigyoshoCd ? self.params.eigyoshoCd + ':' + self.params.eigyoshoNm : ' '
        // 末日99
        var shimeDateText
        switch (self.params.shimeDay.trim()) {
          case '':
            shimeDateText = 'なし '
            break
          case '99':
            shimeDateText = '末日締め '
            break
          default:
            shimeDateText = self.params.shimeDay.trim() + '日締め '
        }
        self.shimeDateText = shimeDateText + filter.dateFormatter(self.params.shiborikomiStartYmd) + ' ～ ' + filter.dateFormatter(self.params.shiborikomiEndYmd)
        self.shiharaishoText = self.params.shiharaisho + ' / ' + self.params.shiharaiNo

        self.conditions.id = self.params.shiharaiId
        self.conditions.shiharaiYmd = filter.dateFormatter(self.params.shiharaiYmd)
        self.conditions.shiharaiYm = self.params.shimeYm ? self.params.shimeYm.trim() : ''
        self.conditions.shimeDay = self.params.shimeDay ? self.params.shimeDay.trim() : ''
        self.conditions.shiborikomiStartYmdString = filter.dateFormatter(self.params.shiborikomiStartYmd)
        self.conditions.shiborikomiEndYmdString = filter.dateFormatter(self.params.shiborikomiEndYmd)
        self.conditions.torihikisakiCd = self.params.shiharaisakiCd ? self.params.shiharaisakiCd : ''
        self.conditions.eigyoshoCd = self.params.eigyoshoCd ? self.params.eigyoshoCd : ''
        self.conditions.shiharaishoKarihakkoFlg = self.params.shiharaishoKarihakkoFlg
        self.conditions.kingakuZeroFlg = self.params.kingakuZeroFlg
        self.conditions.shiharaisho = self.params.shiharaisho
        self.conditions.shiharaiNo = self.params.shiharaiNo ? self.params.shiharaiNo.trim() : ''

        self.HttpClient.post(self.apiPathSearch, self.conditions)
          .then((data) => {
            self.searchResultMethodCustom(data)
            resolve()
          })
      })
    },
    searchResultMethodCustom: function (data) {
      const self = this
      self.rows = []
      if (!self.isShiharaiTorikeshi) {
        // 取消済以外の場合（取消は明細表示しない）
        self.rows = data.payload.vwCD2payd0020List || []
      }
      var initShiharaiKihon = {
        konkaiShiharaiKingaku: 0,
        kihonUnchiGokei: 0,
        warimashiKingakuGokei: 0,
        kazeiKingakuGokei: 0,
        konkaiTax: 0,
        hiwayPriceGokei: 0,
        uchizeiKingakuGokei: 0,
        hikazeiKingakuGokei: 0
      }
      var initMstShiharaisaki = {
        shiharaishoLayoutKbn: false,
        shiharaiMeisaishoLayoutKbn: false
      }

      // 支払基本情報
      if (!self.isShiharai) {
        // 未支払（発注情報）の場合
        self.shiharaiKihon = data.payload.wkShiharaiKihon || initShiharaiKihon
      } else {
        // 支払済（支払情報）の場合
        self.shiharaiKihon = data.payload.trShiharaiKihon || initShiharaiKihon
      }
      // 支払先マスタ情報
      self.shiharaisaki = data.payload.mstShiharaisaki || initMstShiharaisaki

      const cache = {
        rows: self.rows,
        conditions: self.conditions,
        searchText: self.searchText,
        params: self.params
      }
      self.saveToChache(cache)
        .then(() => {
        })
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post(self.apiPathSearch, self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.searchResultMethodCustom(data)
        },
        getSavedInputMethod: function () {
          if (!self.isShiharai) {
            // 未支払時のみの項目
            return {
              kingakuKakutei: self.conditions.kingakuKakutei,
              shimebiIgaiHyojiFlg: self.conditions.shimebiIgaiHyojiFlg,
              shiharaiDomeHyojiFlg: self.conditions.shiharaiDomeHyojiFlg
            }
          } else {
            return {}
          }
        }
      }
      this.search(opt)
    },
    onRowClick: function (row) {
      if (row.trHacchuHinmokuId) {
        if (!this.isShiharai) {
          console.log('発注品目（未出力）id', row.trHacchuHinmokuId)
        } else {
          console.log('発注品目（出力済）id', row.trHacchuHinmokuId)
        }
      } else if (row.trHacchuMeisaiId) {
        if (!this.isShiharai) {
          console.log('発注明細（未出力）id', row.trHacchuMeisaiId)
        } else {
          console.log('発注明細（出力済）id', row.trHacchuMeisaiId)
        }
      } else {
        if (!this.isShiharai) {
          console.log('発注基本（未出力）id', row.trHacchuKihonId)
        } else {
          console.log('発注基本（出力済）id', row.trHacchuKihonId)
        }
      }
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: self.params
          }
        }
      }

      this.transitionBack(opt)
    },
    onCsvButtonClick: function (e) {
      this.Effects.loadStart()
      this.dispShiharaiMeisaiIchiranCsv = `支払明細一覧_${this.getTimeStamp()}.csv`
      this.HttpClient
        .post('/api/v1/d2payd0020/download', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('csvDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.setInvalidSummaryMessage('COMI0005')
          this.Effects.loadComplete()
        })
    },
    // 支払備考入力ダイアログ
    onBikoButtonClick: function () {
      if (this.lastShimeYmd !== '') {
        if (this.shiharaiKihon.shiharaiYmd <= this.lastShimeYmd) {
          this.setInvalidSummaryMessage('BZME0001')
          return false
        }
      }
      // ダイアログ起動時の支払基本情報を保持
      this.shiharaiKihonClone = JSON.parse(JSON.stringify(this.shiharaiKihon))
      this.showShiharaiBikoEditDialog = true
    },
    dialogClosed: function (data) {
      this.showShiharaiBikoEditDialog = false
      if (data === undefined) {
        // ダイアログで閉じるボタン押下
        // ダイアログ起動時の支払基本情報に復元
        this.shiharaiKihon = JSON.parse(JSON.stringify(this.shiharaiKihonClone))
      } else {
        // ダイアログで登録ボタン押下
        this.setInvalidSummaryMessage(data.summaryMessage.messageCd)
        if (data.isValid === true) {
          // 正常
          // 支払基本情報を最新化（更新日時を更新しないと連続登録が不可）
          this.shiharaiKihon = data.payload
        } else {
          // 異常
        }
      }
    },
    onCancelButtonClick: function () {
      // 月次確定処理を行ったデータだった場合、エラー
      if (this.shiharaiKihon.trKessanGetsujiKanriId) {
        this.setInvalidSummaryMessage('BZME0001')
        return false
      }
      const p = modals.showConfirm
      p('COMQ0003').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()
        var list = []
        list.push(this.conditions)
        this.HttpClient.post('/api/v1/d2payd0010/shiharaicancel', list)
          .then((data) => {
            if (data.payload) {
              // 取消処理が正常に終了した場合
              this.params.shiharaisho = '取消済'
            }
            // 画面再表示
            this.initialize()
            // 完了処理
            // this.Effects.loadComplete()
            this.setInvalidSummaryMessage('COMI0005')
          })
      })
    },
    onPrintButtonClick: function (shiharaishoKarihakkoFlg) {
      if (this.lastShimeYmd !== '') {
        if (this.shiharaiKihon.shiharaiYmd <= this.lastShimeYmd) {
          this.setInvalidSummaryMessage('BZME0001')
          return false
        }
      }
      this.loadFromCache()
        .then((c) => {
          if (!this.isShiharai) {
            // 未支払（発注情報）の場合
            var msgInfo = {}
            if (c.value.conditions.shimebiIgaiHyojiFlg) {
              // 再検索を促すメッセージを表示
              msgInfo = JSON.parse(JSON.stringify(message.getInfo('PAYE0005')))
              msgInfo.message = message.get('PAYE0005', ['締日以外の未支払も表示する'])
              this.setSummaryMessage(msgInfo)
              return false
            }
            if (c.value.conditions.shiharaiDomeHyojiFlg) {
              // 再検索を促すメッセージを表示
              msgInfo = JSON.parse(JSON.stringify(message.getInfo('PAYE0005')))
              msgInfo.message = message.get('PAYE0005', ['支払止も表示する'])
              this.setSummaryMessage(msgInfo)
              return false
            }
          }
          this.Effects.loadStart()
          this.dispShiharaisho = `支払書_${this.getTimeStamp()}.pdf`
          // 支払番号は画面再検索時のキーとなりうる項目のため、帳票出力（支払作成）後に対象となった支払番号を取得する必要がある
          var conditions = JSON.parse(JSON.stringify(c.value.conditions))
          var pathPrint = ''
          var pathNoPrint = ''
          if (shiharaishoKarihakkoFlg) {
            // 支払書仮発行の場合
            conditions.shiharaishoKarihakkoFlg = true
            pathPrint = '/api/v1/d2payd0010/printpaymentkari'
            pathNoPrint = '/api/v1/d2payd0010/createshiharaidatakari'
          } else {
            // 支払書発行の場合
            pathPrint = '/api/v1/d2payd0010/printpayment'
            pathNoPrint = '/api/v1/d2payd0010/createshiharaidata'
          }

          if (this.isNotExistShiharaishoLayoutKbn) {
            // 支払レイアウト区分が設定されていない場合
            return this.HttpClient
              // 発行処理前の支払No一覧を取得
              .post('/api/v1/d2payd0020/searchshiharainofromshiharai', conditions)
              .then((before) => {
                var beforeResult = before.payload || []
                this.HttpClient
                  // 非帳票出力処理（支払作成のみ）
                  .post(pathNoPrint, c.value.conditions)
                  .then(data => {
                    // 発行処理後の支払No一覧を取得（発行処理対象の支払Noを抽出）
                    this.searchShiharaiNoAfter(c, conditions, shiharaishoKarihakkoFlg, beforeResult)
                  })
              })
          } else {
            return this.HttpClient
              // 発行処理前の支払No一覧を取得
              .post('/api/v1/d2payd0020/searchshiharainofromshiharai', conditions)
              .then((before) => {
                var beforeResult = before.payload || []
                this.HttpClient
                  // 帳票出力処理
                  .requestFileByPost(pathPrint, c.value.conditions)
                  .then(data => {
                    // aタグにファイル仕込んでClickする処理
                    const blob = new Blob([data], { type: 'application/pdf' })
                    const elem = document.getElementById('shiharaishoDownload')
                    elem.href = window.URL.createObjectURL(blob)
                    elem.click()
                    // 発行処理後の支払No一覧を取得（発行処理対象の支払Noを抽出）
                    this.searchShiharaiNoAfter(c, conditions, shiharaishoKarihakkoFlg, beforeResult)
                  })
              })
          }
        })
    },
    searchShiharaiNoAfter: function (c, conditions, shiharaishoKarihakkoFlg, beforeResult) {
      this.HttpClient
        .post('/api/v1/d2payd0020/searchshiharainofromshiharai', conditions)
        .then((after) => {
          var afterResult = after.payload || []
          var result = afterResult.filter((elem) => {
            return beforeResult.indexOf(elem) === -1
          })
          if (result.length > 0) {
            // 支払情報が作成された場合
            // paramsの値を処理後の情報に更新
            this.params.shiharaisho = '出力済'
            // 支払番号を取得
            this.params.shiharaiNo = result[0]
            if (shiharaishoKarihakkoFlg) {
              // 支払書仮発行の場合
              this.params.shiharaishoKarihakkoFlg = true
            }
            // 画面再検索のために再キャッシュ
            const cache = {
              rows: c.value.rows,
              conditions: c.value.conditions,
              searchText: c.value.searchText,
              params: this.params
            }
            this.saveToChache(cache)
              .then(() => {
              })
            // 画面再表示
            this.initialize()
            // 完了処理
            // this.Effects.loadComplete()
            this.setInvalidSummaryMessage('COMI0005')
          } else {
            // 完了処理
            this.Effects.loadComplete()
            this.setInvalidSummaryMessage('COMI0005')
          }
        })
    },
    onPrintAgainButtonClick: function () {
      this.Effects.loadStart()
      this.dispShiharaisho = `支払書_${this.getTimeStamp()}.pdf`
      var path = '/api/v1/d2payd0010/printpaymentagain'
      if (this.isNotExistShiharaishoLayoutKbn) {
        // 支払レイアウト区分が設定されていない場合
        // 完了処理
        this.Effects.loadComplete()
        this.setInvalidSummaryMessage('COMI0005')
      } else {
        return this.HttpClient
          .requestFileByPost(path, this.conditions)
          .then(data => {
            // aタグにファイル仕込んでClickする処理
            const blob = new Blob([data], { type: 'application/pdf' })
            const elem = document.getElementById('shiharaishoDownload')
            elem.href = window.URL.createObjectURL(blob)
            elem.click()
            // // 画面再表示
            // this.initialize()
            // 完了処理
            this.Effects.loadComplete()
            this.setInvalidSummaryMessage('COMI0005')
          })
      }
    },
    searchValidate: function () {
      return true
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    },
    getShimeJisseki: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get('/api/v1/TrKessanGetsujiKanri/GetAll')
          .then((data) => {
            if (data.payload) {
              var shiharaiShimeList = data.payload.map((elem) => {
                elem.taishoShimeYmd = new Date(elem.taishoYm + '/' + elem.taishoShimeDay)
                return elem
              }).filter(function (elem) {
                return elem.taishoGyomuCd === '02' && elem.delFlg === false
              })
              this.lastShimeYmd = shiharaiShimeList.length !== 0 ? filter.dateFormatter(shiharaiShimeList[shiharaiShimeList.length - 1].taishoShimeYmd) : ''
            }
            resolve()
          })
      })
    }
  }
}
